import React, { useLayoutEffect, useRef, useState, useCallback } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import styles from "./FilterTabsCommon.module.scss";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const FilterTabsCommon = ({ tabs, activeTab, setActiveTab }) => {
    const scrollRef = useRef(null);
    const [showArrows, setShowArrows] = useState({ left: false, right: false });

    const updateScrollState = useCallback(() => {
        const container = scrollRef.current;
        if (container) {
            setShowArrows({
                left: container.scrollLeft > 0,
                right: container.scrollLeft + container.clientWidth < container.scrollWidth,
            });
        }
    }, []);

    const handleScroll = (direction) => {
        const container = scrollRef.current;
        if (container) {
            const scrollAmount = direction === "left" ? -200 : 200;
            container.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
    };

    useLayoutEffect(() => {
        updateScrollState(); // Initial calculation after DOM update
        const container = scrollRef.current;
        if (container) {
            container.addEventListener("scroll", updateScrollState);
        }

        // Cleanup on unmount
        return () => {
            if (container) {
                container.removeEventListener("scroll", updateScrollState);
            }
        };
    }, [updateScrollState, tabs]);

    // Handle window resize to recalculate scrollability
    useLayoutEffect(() => {
        const handleResize = () => updateScrollState();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [updateScrollState]);

    return (
        <div className={styles.filterBar}>
            {showArrows.left && (
                <button
                    className={styles.scrollButton}
                    onClick={() => handleScroll("left")}
                >
                    <FiChevronLeft />
                </button>
            )}

            <div className={styles.filterTabs} ref={scrollRef}>
                <Nav className={styles.fiterTabsNavBar}>
                    {tabs?.map((category) => (
                        <NavItem key={category.id} className={styles.navItem}>
                            <NavLink
                                className={`${styles.navLink} ${activeTab === category.id ? styles.activeTab : ""}`}
                                onClick={() => setActiveTab(category.id)}
                            >
                                {category.label}
                            </NavLink>
                        </NavItem>
                    ))}
                </Nav>
            </div>

            {showArrows.right && (
                <button
                    className={styles.scrollButton}
                    onClick={() => handleScroll("right")}
                >
                    <FiChevronRight />
                </button>
            )}
        </div>
    );
};

export default FilterTabsCommon;
